<template>
  <div>
    <Jumbotron title="" />

    <!-- dekstop -->
    <b-container class="d-none d-sm-block" style="margin-top: -75px;">
      <b-row class="m-3 p-4 sg-rounded-container">
        <b-col cols="12">
          <h3>#CNY2020</h3>
          <h5>🎊Chinese New Years🎊</h5>
        </b-col>

        <b-col cols="6">
          <p class="mt-3">
            Syarat dan Ketentuan
          </p>

          <p>
            <ol>
              <li>Periode Promo: 20 Januari 2020 - 8 Febuari 2020.</li>
              <li>Untuk periode perjalanan sampai dengan Febuari 2020.</li>
              <li>Promo hanya berlaku untuk semua service kecuali (harga menyesuaikan dari persentase diskon).</li>
              <li>Discount langsung dipotong saat melakukan order dari web menggunakan kode promo “CNY2020”.</li>
              <li>Minimal Perjalanan (Booking) 5 hari.</li>
              <li>Promo berlaku untuk semua metode pembayaran.</li>
              <li>Promo tidak dapat digabung oleh promo lain.</li>
              <li>Promo ini berlaku hanya untuk 1 kali pakai.</li>
              <li>No Refund & No Reschedule.</li>
            </ol>
          </p>

          <p class="mt-5">
            Disclaimer
          </p>

          <p>
            <ol>
              <li>Starguides berhak mengubah syarat dan ketentuan promo tanpa pemberitahuan sebelumnya.</li>
              <li>Starguides berhak membatalkan atau memberhentikan promo secara sepihak apabila tidak sesuai dengan syarat dan ketentuan berlaku atau ditemukan adanya kecurangan atau hal yang merugikan pihak Starguides.</li>
              <li>Dengan promo voucher ini, Anda mengerti dan menyetujui semua syarat dan ketentuan yang berlaku.</li>
            </ol>
          </p>
        </b-col>

        <b-col cols="6" class="mt-3 center-base all">
          <b-img
            :src="require('@/assets/img/customer/happy-money.png')"
            style="max-width: 75%;"
          />
        </b-col>
      </b-row>
    </b-container>

    <!-- mobile -->
    <b-container class="d-block d-sm-none" style="margin-top: -5em;">
      <b-row class="m-1 px-1 py-3 sg-rounded-container">
        <b-col cols="12" class="text-center">
          <b-img
            :src="require('@/assets/img/customer/happy-money.png')"
            style="max-width: 50%;"
          />
        </b-col>

        <b-col cols="12" class="mt-3">
          <h4>#CNY2020</h4>
          <h6>🎊Chinese New Years🎊</h6>

          <p class="mt-3">
            Syarat dan Ketentuan
          </p>

          <p>
            <ol>
              <li>Periode Promo: 20 Januari 2020 - 8 Febuari 2020.</li>
              <li>Untuk periode perjalanan sampai dengan Febuari 2020.</li>
              <li>Promo hanya berlaku untuk semua service kecuali (harga menyesuaikan dari persentase diskon).</li>
              <li>Discount langsung dipotong saat melakukan order dari web menggunakan kode promo “CNY2020”.</li>
              <li>Minimal Perjalanan (Booking) 5 hari.</li>
              <li>Promo berlaku untuk semua metode pembayaran.</li>
              <li>Promo tidak dapat digabung oleh promo lain.</li>
              <li>Promo ini berlaku hanya untuk 1 kali pakai.</li>
              <li>No Refund & No Reschedule.</li>
            </ol>
          </p>

          <p class="mt-3">
            Disclaimer
          </p>

          <p>
            <ol>
              <li>Starguides berhak mengubah syarat dan ketentuan promo tanpa pemberitahuan sebelumnya.</li>
              <li>Starguides berhak membatalkan atau memberhentikan promo secara sepihak apabila tidak sesuai dengan syarat dan ketentuan berlaku atau ditemukan adanya kecurangan atau hal yang merugikan pihak Starguides.</li>
              <li>Dengan promo voucher ini, Anda mengerti dan menyetujui semua syarat dan ketentuan yang berlaku.</li>
            </ol>
          </p>
        </b-col>
      </b-row>
    </b-container>

    <b-container class="mt-3" />
  </div>
</template>

<script>
// external dependencies

// custom component
import Jumbotron from '@/components/Jumbotron'

// api call

export default {
  name: 'Promo200120ChineseNewYear',
  components: {
    Jumbotron
  },
  data () {
    return {
    }
  },
  methods: {
    // PREREQUISITES
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Content/Promo200120ChineseNewYear.vue